import SpringConfigs from 'utils/constants/swarm/spring-configs';
import store from 'store';
import { setSportsConfigs } from 'store/actions/app-data';

export const fetchSportsConfigsData = (
  setLoading?: (arg: boolean) => void
): void => {
  if (SpringConfigs.SPORTS_CONFIGS) {
    fetch(SpringConfigs.SPORTS_CONFIGS as string)
      .then(responce => responce.json())
      .then(resp => {
        store.dispatch(setSportsConfigs(resp));
        setLoading && setLoading(false);
      });
  } else {
    setLoading && setLoading(false);
  }
};
